// These constants may be used by clients to create custom CSS.
// For this reason, you may update the constant names as you wish,
// but the string values should always remain the same.
export var RECIPE_CARD_CONTAINER = 'recipe-card';
export var RECIPE_CARD_IMAGE = 'recipe-card__image';
export var RECIPE_CARD_TITLE = 'recipe-card__title';
export var RECIPES_LIST = 'recipes-list';
export var RECIPES_LIST_CONTENT = 'recipes-list__content';
export var RECIPES_LIST_CARD = 'recipes-list__card';
export var RECIPES_LIST_FOOTER = 'recipes-list__footer';
export var RECIPES_LIST_LOAD_MORE = 'recipes-list__load-more';
export var RECIPES_LIST_END_REACHED = 'recipes-list__end-reached';
